<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <div>
        <el-form-item label="机器号">
          <el-input
            v-model="formInline.machineid"
            placeholder="请输入机器号"
          ></el-input>
        </el-form-item>
        <el-form-item label="IMEI号">
          <el-input
            v-model="formInline.imei"
            placeholder="请输入IMEI号"
          ></el-input>
        </el-form-item>
        <el-form-item label="消息时间">
          <el-date-picker
            v-model="formInline.createtime"
            type="datetimerange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-tooltip
            class="item"
            effect="dark"
            content="最多输出300条数据"
            placement="bottom"
          >
            <el-button type="primary" icon="el-icon-search" @click="onSubmit"
              >查询</el-button
            >
          </el-tooltip>
          <el-button
            type="warning"
            icon="el-icon-check"
            @click="setTimeInterval(30)"
            >最近30分</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-caret-left"
            @click="setTimePrev(120)"
            >2H</el-button
          >
          <el-button
            type="success"
            icon="el-icon-arrow-left"
            @click="setTimePrev(60)"
            >1H</el-button
          >
          <el-button
            type="success"
            icon="el-icon-arrow-right"
            @click="setTimeNext(60)"
            >1H</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-caret-right"
            @click="setTimeNext(120)"
            >2H</el-button
          >
        </el-form-item>
      </div>

      <div></div>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="id" width="120"></el-table-column>
      <!-- <el-table-column
        prop="machineid"
        label="machineid"
        width="200"
      ></el-table-column> -->
      <el-table-column prop="imei" label="imei" width="200">
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{ name: 'machine', query: { imei: scope.row.imei } }"
            >{{ scope.row.imei }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="message" label="类型" width="80">
        <template slot-scope="scope">
          <el-tag
            type="success"
            effect="dark"
            size="mini"
            v-if="scope.row.type == 0"
            >接收</el-tag
          >
          <el-tag
            type="normal"
            effect="dark"
            size="mini"
            v-else-if="scope.row.type == 1"
            >发送</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column prop="message" label="消息"></el-table-column>
      <el-table-column label="机器类型/状态" width="160">
        <template slot-scope="scope">
          <div>{{ getMachineType(scope.row.message) }}</div>
          <el-tag
            v-if="getMachineStatusByMessage(scope.row.message)"
            :type="getMachineStatusTagType(scope.row.message)"
            effect="dark"
            size="mini"
            >{{ getMachineStatusByMessage(scope.row.message) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="ICCID" width="120">
        <template slot-scope="scope">
          <div>{{ getICCID(scope.row.message) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="RSSI" width="200">
        <template slot-scope="scope">
          <el-progress
            :text-inside="true"
            :stroke-width="16"
            :percentage="getRSSI(scope.row.message)"
            :color="customColors"
          ></el-progress>
        </template>
      </el-table-column>

      <el-table-column label="时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTimeSSS }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="operator" label="操作员"> </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      formInline: {
        imei: "",
        machineid: "",
        createtime: [moment().subtract(20, "minute"), moment()]
      },
      tableData: [],
      customColors: [
        { color: "#f56c6c", percentage: 50 },
        { color: "#e6a23c", percentage: 80 },
        { color: "#67c23a", percentage: 100 }
      ]
    };
  },

  mounted() {
    if (this.$route.query.machineid) {
      this.formInline.machineid = this.$route.query.machineid;
    }
    if (this.$route.query.imei) {
      this.formInline.imei = this.$route.query.imei;
    }

    if (this.$route.query.from && this.$route.query.to) {
      this.formInline.createtime = [
        this.$route.query.from,
        this.$route.query.to
      ];
      this.onSubmit();
    }
  },
  methods: {
    onSubmit() {
      let queryModel = {
        machineid: this.formInline.machineid,
        imei: this.formInline.imei,
        createtimeFrom: Array.isArray(this.formInline.createtime)
          ? this.$ToDateTimeString(this.formInline.createtime[0])
          : null,
        createtimeTo: Array.isArray(this.formInline.createtime)
          ? this.$ToDateTimeString(this.formInline.createtime[1])
          : null
      };
      console.log(queryModel);
      this.$axios(this.$urlMapping["上报消息查询"], {
        data: queryModel
      }).then(result => {
        console.log(result);
        //let data = result.data;
        this.tableData = result;
      });
    },

    setTimeInterval(val) {
      this.formInline.createtime = [moment().subtract(val, "minute"), moment()];
    },

    setTimePrev(val) {
      let start = moment(this.formInline.createtime[0]).subtract(val, "minute");
      let end = moment(this.formInline.createtime[1]).subtract(val, "minute");
      this.formInline.createtime = [start, end];
    },
    setTimeNext(val) {
      let start = moment(this.formInline.createtime[0]).add(val, "minute");
      let end = moment(this.formInline.createtime[1]).add(val, "minute");
      this.formInline.createtime = [start, end];
    },

    getICCID(val) {
      try {
        let a = JSON.parse(val);
        if (a.report && a.report.iccid) return a.report.iccid;
        if (a.extra && a.extra.ICCID) return a.extra.ICCID;
        return "";
      } catch (e) {
        return "";
      }
    },
    getRSSI(val) {
      try {
        let a = JSON.parse(val);
        let rssi = null;
        if (a.report && a.report.rssi != null) rssi = a.report.rssi;
        else if (a.extra && a.extra.RSSI != null) rssi = a.extra.RSSI;
        if (rssi != null) return Math.trunc((rssi * 100) / 31);
        return 0;
      } catch (e) {
        return 0;
      }
    },
    getMachineType(val) {
      try {
        let data = JSON.parse(val);
        let typeNames = {
          0: "MDC",
          1: "H7S",
          2: "Quantum",
          3: "脉冲控制器",
          4: "脉冲控制器",
          5: "LG洗衣机",
          6: "LG烘干机",
          7: "4G加液器",
          8: "WiFi加液器"
        };
        return typeNames[data.type] || "";
      } catch (e) {
        return "";
      }
    },
    getMachineStatusByMessage(val) {
      try {
        return this.getMachineStatus(JSON.parse(val));
      } catch (e) {
        return "";
      }
    },
    getMachineStatusTagType(val) {
      let statusName = this.getMachineStatusByMessage(val);
      if (statusName === "运行中") return "success";
      let dangerStatus = [
        "离线",
        "故障",
        "门未关",
        "进水超时",
        "排水超时",
        "溢水报警",
        "水位传感器异常"
      ];
      return dangerStatus.indexOf(statusName) >= 0 ? "danger" : "";
    },
    getMachineStatus(data) {
      let type = data.type;
      if (type < 5) {
        if (data.event === "offline") return "离线";
        if (data.event === "online") return "待机";
      }
      if (type === 7 || type === 8) {
        if (data.state === 0) return "离线";
        if (data.state === 1) return "在线";
        return "";
      }
      if (type === 5 || type === 6) {
        if (data.event === "online") return "在线";
        if (data.state === 0) return "离线";
      }

      let mstatus = data.report && data.report.mstatus;
      if (!mstatus) return "";

      if (type < 5) return this.convertBeiErStatus(type, mstatus.status);
      if (type === 5) return this.convertLGWasherStatus(mstatus);
      if (type === 6) return this.convertLGDryerStatus(mstatus);
      return "";
    },
    convertBeiErStatus(type, status) {
      if (type === 0) {
        if (this.getBit(status, 1)) return "待机";
        if (this.getBit(status, 3)) return "启动";
        if (this.getBit(status, 4)) return "运行中";
        if (this.getBit(status, 5)) return "运行结束";
        if (this.getBit(status, 6)) return "故障";
        if (this.getBit(status, 7)) return "菜单模式";
      } else if (type === 1) {
        status = status & 0xff;
        if (status === 0x01) return "待机";
        if (status === 0x04) return "启动";
        if (status === 0x08) return "运行中";
        if (status === 0x0a) return "门未关";
        if (status === 0x0c) return "运行结束";
      } else if (type === 2) {
        if (this.getBit(status, 9)) return "待机";
        if (this.getBit(status, 11)) return "启动";
        if (this.getBit(status, 13)) return "运行结束";
        if (this.getBit(status, 12)) return "运行中";
      } else if (type === 3 || type === 4) {
        return "待机";
      }
      return "故障";
    },
    convertLGWasherStatus(mstatus) {
      let statusName = "故障";
      if (mstatus.process === 0) statusName = "待机";
      else if (mstatus.status === 1) statusName = "门未关";
      else if (mstatus.status === 10) statusName = "运行结束";
      else if (mstatus.status === 20) statusName = "故障";
      else statusName = "运行中";

      if (mstatus.code === 1 || mstatus.code === 17) return "门未关";
      if (mstatus.code === 2) return "进水超时";
      if (mstatus.code === 3) return "排水超时";
      if (mstatus.code === 5) return "溢水报警";
      if (mstatus.code === 6) return "水位传感器异常";
      if ([4, 7, 8, 9, 10, 12, 13, 14].indexOf(mstatus.code) >= 0) {
        return "故障";
      }
      return statusName;
    },
    convertLGDryerStatus(mstatus) {
      let statusName = "故障";
      if (mstatus.status === 0) statusName = "待机";
      else if (mstatus.status === 1) statusName = "运行中";

      if (mstatus.code > 0) return mstatus.code === 5 ? "门未关" : "故障";
      return statusName;
    },
    getBit(num, index) {
      return (num >> index) & 1;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}
</style>
